export const customComponentsToolbarGroupId = "dextall-editor-custom-components-tools-control-group";

export const hooksToolbarGroupId = "dextall-editor-hooks-tools-control-group";

export const undoRedoToolsToolbarGroupId = "dextall-editor-undo-redo";

export const measureToolsToolbarGroupId = "measureTools";

export const settingsToolsToolbarGroupId = "settingsTools";
